import apigee from "./apigee";
// import localAPI, { testAPI } from "./localApi";

// const { NODE_ENV } = process.env;

// export default NODE_ENV === "development" || window.location.hostname === "localhost" ?
//     localAPI : (window.location.hostname === "" ? testAPI : apigee);
export default apigee;